import levenshtein from 'fast-levenshtein';
import { pick } from 'lodash';
import { z } from 'zod';

export enum ConditionalField {
  COMMODITY = 'COMMODITY',
  IS_CONSOLIDATED = 'IS_CONSOLIDATED',
  HS_CODE = 'HS_CODE',
  IS_MILITARY_RELATED = 'IS_MILITARY_RELATED',
  EMERGENCY_CONTACT = 'EMERGENCY_CONTACT',
}

export const ConditionalSchema = {
  hs_code: z.string().min(1, {
    message: 'A HS code is required.',
  }),
  commodity: z.string().refine(
    (rawCommodity) => {
      const forbidden = [
        'general cargo',
        'consolidated cargo',
        'consolidated goods',
        'general goods',
        'general pharma',
        'consolidation',
      ];
      const commodity = rawCommodity.toLowerCase().trim();
      return !forbidden.some((bad) => commodity === bad || levenshtein.get(bad, commodity) <= 1);
    },
    {
      message: 'Please be more specific.',
    },
  ),
  is_military_related: z.boolean(),
  emergency_contact: z.number(),
  is_consolidated: z.boolean({ required_error: 'Please answer whether there will be HAWBs' }),
} as const satisfies { [key in Lowercase<ConditionalField>]: any };

export const getConditionalSchema = (fields: ConditionalField[]) => {
  return pick(ConditionalSchema, fields?.map?.((field) => field.toLowerCase()) || []);
};
